import React, { useState } from "react";
import { Form, Button, Modal, Row, Col } from "antd";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import useStore from "../../../../store";
import { vsmInsuranceCopyProducts, vsmNotify } from "../../../../config/messages";
import InputComponent from "../../../../component/InputComponent";
import debounce from "lodash/debounce";

const CopyComponent = observer((props) => {
	const [form] = Form.useForm();
	const [saving, setSaving] = useState();
	const [disabled, setDisabled] = useState(true);

	const {
		InsuranceProductStore: { copyInsuranceProduct, editValues },
	} = useStore();

	// Handle submit and call function to save new record
	const handleSubmit = (data) => {
		data.id = editValues.id;
		copyInsuranceProduct(data).then((data) => {
			vsmNotify.success({
				message: data.STATUS.NOTIFICATION[0],
			});
			close();
		})
			.catch((e) => {
				// console.log("error......", e);
				if (e.errors) {
					form.setFields(e.errors);
				}
			})
			.finally(() => setSaving(false));
	};

	// check for valid form values then accordingly make save button disable/enable
	const handleChange = debounce(() => {
		form
			.validateFields()
			.then((d) => {
				setDisabled(false);
			})
			.catch((d) => {
				setDisabled(true);
			});
	}, 500);

	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
		setDisabled(true);
	};

	return (
		<Modal
			className="addModal"
			centered
			title={`Copy Insurance Product`}
			width={500}
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onCancel={close}
			cancelButtonProps={{ style: { display: "none" } }}
			okButtonProps={{ style: { display: "none" } }}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Cancel
				</Button>,
				<Button
					key="1"
					disabled={disabled}
					form="copyInsuranceForm"
					loading={saving}
					htmlType="submit"
					type="primary"
				>
					Copy
				</Button>,
			]}
		>
			<Form
				form={form}
				id="copyInsuranceForm"
				onFinish={handleSubmit}
				labelCol={{ span: 24 }}
				onChange={handleChange}
			>
				<Row>
					<Col xs={{ span: 24 }}>
						<InputComponent
							type="text"
							required
							label="Name"
							placeholder="Name"
							name="name"
							onChange={handleChange}
							rules={vsmInsuranceCopyProducts.validation.name}
						/>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
});

export default CopyComponent;
